import { render, staticRenderFns } from "./WorkerGroupList.vue?vue&type=template&id=f2df6fd6&"
import script from "./WorkerGroupList.vue?vue&type=script&lang=js&"
export * from "./WorkerGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports